import { combineReducers } from 'redux'

import initialState from './initial_state'
import { LOAD, LOAD_ANSWER, SET_STATUS } from './constants'
import { IInquiry, IAnswer, Status } from './types'

export default combineReducers({
  byId: (state = initialState, action: any) => {
    let handlers: any = {
      [LOAD]: (state: any, { inquiry }: { inquiry: IInquiry }) => {
        return {
          ...state,
          [inquiry.calculatorId]: inquiry
        }
      },

      [LOAD_ANSWER]: (
        state: any,
        { calculatorId, answer }: { calculatorId: string; answer: IAnswer }
      ) => {
        return {
          ...state,
          [calculatorId]: {
            ...state[calculatorId],
            status: 'COMPLETE',
            answer
          }
        }
      },

      [SET_STATUS]: (
        state: any,
        { calculatorId, status }: { calculatorId: string; status: Status }
      ) => {
        return {
          ...state,
          [calculatorId]: {
            ...state[calculatorId],
            status
          }
        }
      }
    }

    let handler = handlers[action.type]

    if (typeof handler === 'function') {
      return handler(state, action.payload)
    }

    return state
  }
})
